import React from "react"
import { useCustomerInfo } from "../../CustomerInfo"
import { useTranslationsContext } from "./Translations"

export const WithLoginPageFallback = ({ children }) => {
	const customerInfo = useCustomerInfo()
	const { translations } = useTranslationsContext()

	const customerInfoIsReady = !!customerInfo.data
	const translationsAreReady = !!translations

	// TODO: Add the fallback component (if needed)
	return <>{customerInfoIsReady && translationsAreReady ? children : null}</>
}
